import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetItemComponentIdentityByIdRequest,
    type GetItemComponentIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const useItemComponentIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetItemComponentIdentityByIdResponse,
        GetItemComponentIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetItemComponentIdentityByIdResponse> =>
            new GetItemComponentIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetItemComponentIdentityByIdResponse>) =>
                response?.data?.itemComponentIdentity,
            getError: (response?: SWRResponse<GetItemComponentIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default useItemComponentIdentityById;
